import React from 'react';

import AssetsBuyingSignContainer from '../../../containers/assets-buying-sign-container';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';

const AssetsSigningPage: React.FC = () => (
  <AppPageMain>
    <div className="container">
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/assets', title: 'Активы' },
              { link: '#', title: 'Покупка' },
            ]}
            iconType="assets"
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19 col-lg-27 col-xl-35">
          <AssetsBuyingSignContainer />
        </div>
      </div>
    </div>
  </AppPageMain>
);

export default AssetsSigningPage;
